import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserAccountService } from '../_services/user-account.service';
import { first } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { NewUserRequestModel } from '../_models/new-user-request-model';

import { ApiResultErrorDialogComponent } from '../api-result-error-dialog/api-result-error-dialog.component';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css']
})
export class AddUserComponent implements OnInit {


  newUserForm: FormGroup;

  loading = false;
  submitted = false;
  returnUrl: string;
  error = "";

  public firstName: string = "";
  public lastName: string = "";
  public emailAddress: string = "";
  public password: string = "";
  public phoneNumber: string = "";

  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private userAccountService: UserAccountService,
    protected dialog: MatDialog
  ) {

    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

  }

  onSubmit() {
    this.submitted = true;

    if (this.newUserForm.invalid) {
      return;
    }

    let reqModel: NewUserRequestModel = {
      firstName: this.f.firstName.value,
      lastName: this.f.lastName.value,
      email: this.f.emailAddress.value,
      password: this.f.password.value,
      phone: this.f.phoneNumber.value,
      operators: []
    };


    this.userAccountService.adminSubmitNewUser(reqModel).then(
      (res) => {
        if (!res.Success) {
          let errorObj = {
            Reasons: res.Reasons
          }
          this.dialog.open(ApiResultErrorDialogComponent, { data: errorObj });
        } else {
        this.router.navigate(['/admincp']);
        }
      }
    )
  }

  get f() { return this.newUserForm.controls; }

  ngOnInit(): void {
    this.newUserForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      emailAddress: ['', Validators.required],
      password: ['', Validators.required],
      phoneNumber: ['', Validators.required]
    });
  }

}
